import type { FieldSuggestionItem } from './extensions/fieldSuggestion';

export interface FieldGroup {
	name: string;
	items: FieldSuggestionItem[];
}

const UNGROUPED = 'Other';

/**
 * The palette's entries under their own headings, in the order the catalogue gave them.
 *
 * A flat list of every data point ran to a hundred rows, which is why an author scrolling for
 * a security landed among `holdings_0.…` with nothing saying what any of it belonged to. The
 * catalogue already states the object each value comes from; this is only reading it.
 */
export const groupFields = (items: FieldSuggestionItem[]): FieldGroup[] => {
	const groups: FieldGroup[] = [];
	const byName = new Map<string, FieldGroup>();
	for (const item of items) {
		const name = item.group ?? UNGROUPED;
		let group = byName.get(name);
		if (group === undefined) {
			group = { name, items: [] };
			byName.set(name, group);
			groups.push(group);
		}
		group.items.push(item);
	}
	return groups;
};
